export const languageDictionary = {
    "en-GB": "English",
    "nl-NL": "Nederlands",
}
